const userTimeFormat = {
    24: 'HH:mm:ss',
    12: 'hh:mm:ss a',
    '24_hour_minutes': 'HH:mm',
    '12_hour_minutes': 'hh:mm a'
};

export default userTimeFormat;
